import React, { useState, useEffect } from "react";
import styled from "styled-components";

const ArticlePageContainer = styled.div`
  width: 80%;
  margin: 0 auto;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

const Button = styled.button`
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
`;

const ArticleForm = styled.form`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const Input = styled.input`
  margin-bottom: 10px;
`;

const TextArea = styled.textarea`
  margin-bottom: 10px;
`;

const BlockContainer = styled.div`
  margin-bottom: 10px;
`;

const BlockType = styled.select`
  margin-right: 10px;
`;

const BlockInput = styled.input`
  margin-bottom: 10px;
`;

const ArticleList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 20px;
`;

const Article = styled.div`
  border: 1px solid #ddd;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(60%);
`;

const ImageContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  transition: transform 0.3s;
  z-index: 1;

  &:hover {
    transform: scale(1.05);
  }
`;

const InfoContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  opacity: 1;
  transition: opacity 0.3s, transform 0.3s;
  transform: translateY(0);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 2;

  ${ImageContainer}:hover & {
    opacity: 0;
    transform: translateY(100%);
  }
`;

const Title = styled.h3`
  margin: 0;
  font-size: 20px;
`;

const Author = styled.p`
  margin: 8px 0 0;
  font-size: 16px;
`;

const Content = styled.div`
  padding: 20px;
`;

const isAdmin = true; // Set to true for admin view, false for regular user view

const ArticlePage = () => {
  const [viewMode, setViewMode] = useState(true);
  const [articles, setArticles] = useState([]);
  const [blocks, setBlocks] = useState([{ type: "h1", content: "" }]);

  useEffect(() => {
    // Simulating API call to fetch articles
    fetchArticles();
  }, []);

  const fetchArticles = () => {
    // Simulated API response
    const dummyArticles = [
      {
        id: 1,
        title: "Article 1",
        author: "John Doe",
        content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        date: "2023-06-16",
        image:
          "https://images.pexels.com/photos/2635038/pexels-photo-2635038.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      },
      {
        id: 2,
        title: "Article 2",
        author: "Jane Smith",
        content:
          "Sed ut perspiciatis unde omnis iste natus error sit voluptatem.",
        date: "2023-06-16",
        image:
          "https://images.pexels.com/photos/2395205/pexels-photo-2395205.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      },
      // Add more articles here
    ];

    setArticles(dummyArticles);
  };

  const handleToggleView = () => {
    setViewMode(!viewMode);
  };

  const handleBlockTypeChange = (index, event) => {
    const updatedBlocks = [...blocks];
    updatedBlocks[index].type = event.target.value;
    setBlocks(updatedBlocks);
  };

  const handleBlockContentChange = (index, event) => {
    const updatedBlocks = [...blocks];
    updatedBlocks[index].content = event.target.value;
    setBlocks(updatedBlocks);
  };

  const handleAddBlock = () => {
    const updatedBlocks = [...blocks];
    updatedBlocks.push({ type: "h1", content: "" });
    setBlocks(updatedBlocks);
  };

  const handleRemoveBlock = (index) => {
    const updatedBlocks = [...blocks];
    updatedBlocks.splice(index, 1);
    setBlocks(updatedBlocks);
  };

  const handleCreatePost = (e) => {
    e.preventDefault();
    // Logic for creating a new post
  };

  return (
    <ArticlePageContainer>
      <ButtonContainer>
        {isAdmin && (
          <Button onClick={handleToggleView}>
            {viewMode ? "Create Post" : "View Posts"}
          </Button>
        )}
      </ButtonContainer>

      {viewMode ? (
        <ArticleList>
          {articles.length > 0 ? (
            articles.map((article) => (
              <Article key={article.id}>
                <ImageContainer>
                  <Image src={article.image} alt={article.title} />
                  <InfoContainer>
                    <Title>{article.title}</Title>
                    <Author>By {article.author}</Author>
                  </InfoContainer>
                </ImageContainer>
              </Article>
            ))
          ) : (
            <p>No articles available.</p>
          )}
        </ArticleList>
      ) : (
        <ArticleForm onSubmit={handleCreatePost}>
          {blocks.map((block, index) => (
            <BlockContainer key={index}>
              <BlockType
                value={block.type}
                onChange={(event) => handleBlockTypeChange(index, event)}
              >
                <option value="h1">H1</option>
                <option value="h2">H2</option>
                <option value="h3">H3</option>
                <option value="p">P</option>
                <option value="space">Space</option>
              </BlockType>
              {block.type !== "space" && (
                <BlockInput
                  type="text"
                  placeholder="Content"
                  value={block.content}
                  onChange={(event) => handleBlockContentChange(index, event)}
                />
              )}
              {blocks.length > 1 && (
                <Button type="button" onClick={() => handleRemoveBlock(index)}>
                  Remove
                </Button>
              )}
            </BlockContainer>
          ))}
          <Button type="button" onClick={handleAddBlock}>
            Add Block
          </Button>
          <Button type="submit">Create Post</Button>
        </ArticleForm>
      )}
    </ArticlePageContainer>
  );
};

export default ArticlePage;
